import React from 'react';
import { CtaButton } from '../CtaButton';
export function About() {
  return <section className="w-full bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-59" data-mp="or48z8g6lnzz">
      <div className="mx-auto w-full max-w-4xl" data-id="element-60" data-mp="oqvujc4euamo">
        <div className="text-center" data-id="element-61" data-mp="12r6q2sgo0de6">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-62" data-mp="12q40cnv2wgzu">
            🩺 About Dr. Karito
          </p>
          <h2 className="mx-auto mt-3 max-w-2xl font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-63" data-mp="azqwgegoxqeg">
            The problem wasn’t a lack of knowledge. It was a lack of a practical
            way to apply it.
          </h2>
        </div>

        <div className="mt-9 grid grid-cols-1 items-start gap-7 md:grid-cols-[minmax(0,260px)_1fr] md:gap-9" data-id="element-64" data-mp="jtc99s9aoxl8">
          <figure className="mx-auto w-full max-w-[260px]" data-id="element-65" data-mp="ez83hcbrmvlq">
            <img src="https://cdn.magicpatterns.com/uploads/pkubTzwtYLM9j5ioT4EDSM/Dra_Karito_real.png" alt="Dr. Karito, physician and creator of Hypertension Route" className="w-full rounded-2xl object-cover ring-1 ring-white/15" width={942} height={1570} data-id="element-66" data-mp="3nfte0xk1pwqy" />
            <figcaption className="mt-3 text-center text-[12px] font-bold uppercase tracking-[0.14em] text-white/55" data-id="element-67" data-mp="385ysekw88cj4">
              Dr. Karito · Creator of Hypertension Route
            </figcaption>
          </figure>

          <div className="flex flex-col gap-4 text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-68" data-mp="2kambmjsthrub">
            <p data-id="element-69" data-mp="2p97buj82kbir">For years, I saw the same problem again and again:</p>
            <p className="border-l-2 border-blood pl-4 font-medium text-white" data-id="element-70" data-mp="2pbjuyzpkcrxe">
              Dedicated physicians making important decisions while trying to
              piece together recommendations scattered across different
              guidelines.
            </p>
            <p data-id="element-71" data-mp="9ht9ypsyjgci">
              The knowledge was there. What was missing was a clear clinical
              path. That’s why Hypertension Route was created — not as another
              manual to leave sitting in a folder, but as a practical clinical
              system designed to accompany you during the consultation and help
              you answer the question that actually matters:
            </p>
            <p className="font-display text-xl font-bold italic leading-snug text-white sm:text-2xl" data-id="element-72" data-mp="2jkpbvw7dkuvs">
              “What is the next step for this patient?”
            </p>
            <p data-id="element-73" data-mp="1rv4a7gh3b09n">
              Every algorithm, protocol and clinical tool was created to
              simplify complex decisions and turn evidence into practical
              action. When you have a clear route, the way you practice medicine
              changes — and so does the confidence you bring into every patient
              interaction.
            </p>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-74" data-mp="1850leuuwxdq8">
          <CtaButton label="I want Dr. Karito’s Hypertension Route" variant="light" data-id="element-75" data-mp="183pkd2suqk2t" />
        </div>
      </div>
    </section>;
}